<template>
    <MainContent title="Liberar Asiento">
        <template v-slot:header>
            <h3 class="card-title">Listado de eventos</h3>
        </template>
        <template v-slot:content>
            <div class="row" v-if="eventos">
                <div v-if="eventos.length == 0">
                    <div class="col-12">
                        <div class="alert alert-info" role="alert">
                            <h4 class="alert-heading">No hay eventos</h4>
                            <p>No hay eventos para este abonado</p>
                        </div>
                    </div>
                </div>
                <div class="col-3" v-for="evento in eventos" :key="evento.id">
                    <b-card bg-variant="light">
                        <div class="text-center">
                            <span v-if="evento.equipo_local && evento.equipo_visitante">
                                <b>{{evento.equipo_local.nombre}} VS {{evento.equipo_visitante.nombre}}</b>
                            </span>
                            <span v-else>
                                <b>EVENTO SIN EQUIPOS</b>
                            </span>
                        </div>
                        <div class="text-center">
                            <span><b>{{evento.fecha}}</b></span>
                            <p><b>{{evento.hora}}</b></p>
                        </div>

                        <div class="row justify-content-center" v-if="!evento.asientos_liberados">
                            <b-form-group label="Selecione la sesion" v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                    v-for="sesion in evento.sessiones"
                                    :key="sesion.id"
                                    class="col-12"
                                    :disabled="sesion.asiento_liberado"
                                    v-model="selectedSesion"
                                    :aria-describedby="ariaDescribedby"
                                    name="sesion"
                                    :value="sesion"
                                >
                                    {{sesion.fecha}} {{sesion.hora}}
                                </b-form-radio>
                            </b-form-group>
                        </div>
                       
                        <div class="mt-2 row justify-content-center">
                            <Button @click="showModal('liberarAsiento' , evento , selectedSesion)" v-if="!evento.asientos_liberados">Liberar</Button>
                            <p class="badge badge-success text-wrap" v-else>Asiento Liberado</p>
                        </div>
                    </b-card>
                </div>
                <LiberarAsiento
                    :abonado_id="abonado_id"
                    :evento="evento"
                    :sesion="sesion"
                    @close="closeModal('liberarAsiento')" 
                />
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import LiberarAsiento from "./modals/LiberarAsiento.vue";
    export default {
        props: ['abonado_id'],
        data() {
            return {
                loading: false,
                eventos: null,
                evento: null,
                selectedSesion: null,
                sesion: null,
            }
        },
        methods: {
            getEventos() {
                this.loading = true
                const params = {
                    filters : {},
                    abonado_id: this.abonado_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.eventos'), params).then(res => {
                    this.eventos = res.data.data;
                    this.loading = false;
                });

            },
            showModal(modal, evento, sesion) {
                this.evento = evento;
                this.sesion = sesion;
                if(this.evento && this.sesion){
                    this.$modal.show(modal);
                }
            },
            closeModal(modal) {
                this.getEventos();
                this.$modal.hide(modal);
            },
        },
        created() {
            this.getEventos();
        },
        components:  {
            MainContent, LiberarAsiento
        }
    }
</script>